import { FC, useState } from "react";
import { useRouter } from "next/router";
import { Specification } from "@prisma/client";

import Accordion from "@components/common/accordion";
import { classNames } from "@utils/class-names";

const SpecComponent: FC<Specification> = ({
  name,
  content,
  nameEn,
  contentEn,
}) => {
  const [expanded, onExpandToggle] = useState(false);
  const { locale } = useRouter();

  return (
    <Accordion
      className="border-b py-3 border-black"
      {...{
        header: (
          <div className="flex justify-between">
            <div className="uppercase">{locale === "en" ? nameEn : name}</div>
            <div className="relative w-5 h-5">
              <div
                className={classNames(
                  "plus-horizontal transform duration-200 ",
                  expanded ? "rotate-180" : ""
                )}
              />
              <div
                className={classNames(
                  "plus-vertical transform duration-200 ",
                  expanded ? "rotate-90" : "-rotate-180"
                )}
              />
            </div>
          </div>
        ),
        expanded,
        onExpandToggle,
      }}
    >
      <div
        className="prose pt-2 text-sm max-w-none"
        dangerouslySetInnerHTML={{
          __html: locale === "en" ? contentEn : content,
        }}
      />
    </Accordion>
  );
};

export default SpecComponent;
